'use client';
import { merriweather } from '@/app/fonts';
import { Mail } from 'lucide-react';
import { Logo } from './logo';


export const SUPPORT_EMAIL = 'support@weeamici.com';
export const ACCESSIBILITY_EMAIL = 'accessibility@weeamici.com';

const legalLinks = [
  { label: 'Member Agreement', href: '/member-agreement' },
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Cookie Policy', href: '/cookies-policy' },
  { label: 'Community Guidelines', href: '/guidelines/forums' },
  { label: 'Your Privacy Choices', href: '/your-privacy-choices' },
];

export function LandingFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      className={`${merriweather.className} shrink-0 bg-[#eae7e0] border-t border-[#cdc4c1] px-5 md:px-10 lg:px-22 4xl:px-50 py-2.5 md:py-3`}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-3">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 shrink-0">
          {/* Decorative here — the wordmark repeats the copyright line beside it. */}
          <Logo showDescription={false} className="h-5 w-auto" aria-hidden="true" />
          <span className="text-[11px] text-[#554E49]">
            © {year} Wee Amici
          </span>
          {/* Sits with the copyright rather than in the legal row, carrying just
              enough weight not to read as more fine print. */}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="inline-flex items-center gap-1.5 text-[12px] font-bold text-[#5B493C] underline-offset-2 transition-colors hover:text-black hover:underline"
          >
            <Mail size={13} strokeWidth={2} aria-hidden="true" />
            <span>Contact us</span>
          </a>
        </div>

        <ul className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-[#5B493C]">
          {legalLinks.map((link) => (
            <li key={link.href}>
              <a href={link.href} className="hover:text-black transition-colors">
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* A closing note under the bar rather than a titled section — no
          heading, so it reads as one sentence at footer scale. "Email us:"
          carries the address: a bare mailto after a full stop looks like a
          stray fragment, and the label is what makes it obviously clickable. */}
      <div className="border-t border-[#cdc4c1] mt-2.5 pt-2 md:mt-3 md:pt-2.5 text-[11px] leading-relaxed text-[#554E49]">
        Something hard to use? Tell us — we treat it as our bug, not yours.
        Email us:{' '}
        <a
          href={`mailto:${ACCESSIBILITY_EMAIL}`}
          aria-label={`Report an accessibility problem — email ${ACCESSIBILITY_EMAIL}`}
          className="font-bold text-[#5B493C] underline-offset-2 transition-colors hover:text-black hover:underline break-all"
        >
          {ACCESSIBILITY_EMAIL}
        </a>
      </div>
    </footer>
  );
}
